import React from 'react';
import PageWithHeader from "../common/PageWithHeader";
import {Box, Button, Paper, Typography} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import LifeWheelVisualisation from "./LifeWheelVisualisation";
import {useGetLifeWheelByIdQuery} from "../../redux/vmsApi";
import LoadingCover from "../common/LoadingCover";
import {useRouter} from "../../hooks/useRouter";
import {useParams} from "react-router-dom";

const AdminLifeWheel: React.FC = () => {
  const params = useParams();
  const router = useRouter();

  const { data: lifeWheelData, isLoading} = useGetLifeWheelByIdQuery({id: params?.uuid ?? ""})

  return (
    <PageWithHeader>
      <Box padding={5}>
        <Button color="primary" onClick={() => router.push('/reviews/admin')}>
          <ArrowBackIcon/>
          <Typography color="primary" align="left">Admin Dashboard</Typography>
        </Button>
        <Paper
          elevation={3}
          sx={{
            paddingY: 15,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center'
          }}
        >
          {(!isLoading && lifeWheelData) ? (
            <LifeWheelVisualisation data={lifeWheelData.responses[0]} width={600} />
          ) : (
            <LoadingCover />
          )}
        </Paper>
      </Box>
    </PageWithHeader>
  )
}

export default AdminLifeWheel;